import type { Styles } from '@adornis/ass/style.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../theme/d-icon.js';

@customElement('component-badge')
export class ComponentBadge extends ChemistryLitElement {
  @property({ attribute: 'color', type: String }) color = this.colors.tone.secondaryText?.string;
  @property({ attribute: 'background', type: String }) background = this.colors.tone.neutralAlabster?.string;

  @property({ attribute: 'border-radius', type: String }) borderRadius: string = '4px';
  @property({ attribute: 'invert', type: Boolean }) invertColors = false;
  @property({ attribute: 'small', type: Boolean }) isSmall = false;
  @property({ attribute: 'icon', type: String }) icon: Maybe<string>;
  @property({ attribute: 'text', type: String }) text: Maybe<string>;

  @property({ attribute: false }) additionalTextStyle: Styles = {};

  override render() {
    return html`
      <d-flex
        space="xs"
        horizontal
        crossaxis-center
        ${css({
          background: this.invertColors ? this.color : this.background,
          padding: this.isSmall ? '2px 4px' : DesignSystem.currentTheme.getValue().spacing.xs,
          borderRadius: this.borderRadius,
          color: this.invertColors ? this.background : this.color,
          height: this.isSmall ? '24px' : '28px',
        })}
      >
        ${this.icon ? html` <d-icon> ${this.icon} </d-icon> ` : nothing}
        <d-text ${css({ fontSize: '14px', ...this.additionalTextStyle })}>${this.text}</d-text>
      </d-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          display: 'contents',
        },
      },
    ] as Styles[];
  }
}
